/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import PaginationInfo from './PaginationInfo'
import PaginationLimits from './PaginationLimits'
import PaginationNav from './PaginationNav'
import { ButtonProps, Group, GroupProps, TextProps } from '@mantine/core'

export type PaginationProps = GroupProps & {
  limits?: number[],
  navButtonProps?: ButtonProps,
  textProps?: TextProps,
}

function Pagination (props: PaginationProps) {
  const {
    limits,
    navButtonProps,
    ...others
  } = props

  return (
    <Group gap="xs" {...others}>
      <PaginationNav buttonProps={navButtonProps} />
      <PaginationInfo />
      <PaginationLimits limits={limits} />
    </Group>
  )
}

export default Pagination
